<div class="hisSearchResultPageElementsInViewport">
  @if (pageTitle && showTitle) {
    <his-heading [level]="headingLevelPageTitle" [value]="pageTitle | hisUi" />
  }

  <!-- If a resultListTemplate is given via input then the resultTable will not be displayed.
  The relevant variables which contain the found objects and information for the pagination
  is given to the loaded template context to be used in the resultList. -->
  	<ng-container *ngTemplateOutlet="(resultListTemplate && showList()) ? resultListTemplate : defaultResultTable;
  		context: {$implicit: rowContext.rows, first: firstResultRow, totalRecords: totalRowCount,
        rowsPerPage: rowsPerPage}"></ng-container>

  <!-- ng-template necessary to prevent rendering if template for a resultList is given -->
  <ng-template #defaultResultTable>
    <div class="genericSearchButtons" appScrollwithme>
      <!-- Standard buttons -->
      @if (showNewSearchButton) {
        <button type="submit" iconPos="left" (click)="newSearch()" class="newSearchButton">
          <span>{{'de.his.javang.newsearch'|hisUi}}</span>
        </button>
      }
      @if (showChangeSearchButton) {
        <button class="changeSearchButton" type="submit" iconPos="left" (click)="changeSearch()">
          <span>{{'de.his.javang.changesearch'|hisUi}}</span>
        </button>
      }

      <!-- Custom buttons -->
      <ng-content select="[customResultButtons]"></ng-content>

      @if (searchShowPrintviewButton) {
      <button
        id="showPrintview"
        hisImage="PRINTER_L"
        iconPos="left"
        (click)="showPrintview()"
        [title]="'de.his.javang.printview' | hisUi">
      </button>
    }

    <ng-content select="[customContentAboveTable]"></ng-content>

    @if (doShowJobStarter) {
      <his-job-starter
        [key]="jobStarterKey"
        [search]="search"
        [searchConfigFile]="searchConfigFile"
        [selectedOptions]="rowContext.selectedOptions()">
      </his-job-starter>
    }
    </div>



    @if (selectionSetting === selectionSettingEnum.MultiSelect || doShowJobStarter) {
      <div class="tableSelectItemsButtonBlock">
        <his-search-result-selected-items
          [currentSearch]="searchToUseOverlay"
          [columns]="columns"
          [selectedOptions]="rowContext.selectedRows()"
          [selectedOptionsIdColumn]="selectedOptionsIdColumn"
          [selectedOptionsLabelColumn]="selectedOptionsLabelColumn"
          [idColumn]="idColumn"
          (deselectedOptions)="handleUpdateSelectedItems($event)" />

        <his-search-result-select-buttons
          (selectAllItems)="handleSelectAllItems()"
          (clearSelectedItems)="handleClearSelectedItems()"/>
        
        <!-- hier kann man z.B. einen Link zum Löschen der ausgewählten Elemente einbauen -->
        <ng-content select="[customContentAfterSelectButtons]"></ng-content>
      </div>
    }
    
    <div>
      <div class="floatLeft">
        @if (tableTitle) {
        <his-heading [level]="headingLevelTableTitle" value="{{tableTitle | hisUi}}" />
        }
      </div>
    
      <div class="tableFilterEditBlock">
        <!-- button Filter anzeigen / Filter ausblenden  -->
        @if (showTableFilter) {
        <span>
          @if(toggleTableFilter){
            <button class="transparent hideOnMobile" (click)="toggleFilter(); $event.preventDefault();" hisImage="FILTER_RESET">
            <span>{{ 'de.his.faces.tags.table.tableFilter.disable' | hisUi }}</span>
          </button>
          }
          @else{
          <button class="transparent hideOnMobile" (click)="toggleFilter(); $event.preventDefault();" hisImage="FILTER">
            <span>{{ 'de.his.faces.tags.table.tableFilter.enable' | hisUi }}</span>
          </button>
          }
        </span>
        }
    
        <!-- Tabelle anpassen -->
        @if (showTableConfig) {
        <span class="hideOnMobile">
          <his-search-result-config
            [configColumns]="configColumns"
            [showPaginator]="showPaginator"
            [maxRows]="maxRows"
            (saved)="onTableConfigChanged()"
            [tableId]="userProfileKeyBasePath">
          </his-search-result-config>
        </span>
        }
    
        <ng-content select="[customResultButtonsAfterJobStarter]"></ng-content>
    
        @if (resultListTemplate) {
        <button (click)="switchListTable()" class="transparent">
          <img hisImage="TEXT_LIST_BULLETS" class="inlineicon" [title]=" ">
          <span>{{'de.his.javang.button.selectList' | hisUi}}</span>
        </button>
        }
      </div>
      <div class="clearer"></div>
    </div>
    <div class="clearerSpaceAboveHalfEm"></div>

    @if (resultRowsLimitedMessage) {
      <div class="infoMessage">{{ resultRowsLimitedMessage | hisUi : maxResultRows }}</div>
    }
    <div class="clearerSpaceAboveHalfEm"></div>

    @if (showSearchInfo) {
      <div>
        <his-search-result-search-info
          [queryParams]="queryParams"
          [searchConfigFile]="searchConfigFile">
        </his-search-result-search-info>
        <div class="clearerSpaceAboveHalfEm"></div>
      </div>
    }

    <p-table #searchResultTable
             disableHisTableDirective
             [hisTableId]="userProfileKeyBasePath"
             disableTableIdGeneration
             [value]="rowContext.rows"
             sortMode="multiple"
             [multiSortMeta]="currentMultiSortMeta"
             [resetPageOnSort]="false"
             [paginator]="showPaginator"
             [paginatorPosition]="paginatorPosition()"
             [totalRecords]="totalRowCount"
             [lazy]="true"
             [style]="resultTableStyle"
             [rowHover]="true"
             [compareSelectionBy]="'equals'"
             [rows]="rowsPerPage"
             [(first)]="firstResultRow"
             [(selection)]="rowContext.activePageSelection"
             [dataKey]="'rowKey'"
             (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
             (onLazyLoad)="load($event)"
             (onPage)="onPage($event); searchResultTable?.el?.nativeElement?.scrollIntoView(({block: 'start', behavior: 'smooth'}));"
             [lazyLoadOnInit]="!isSearchPopup"
             [hisFrozencol]="frozenCols">
      <!-- [rowsPerPageOptions]="[5,10,20,50,100]" -->

      <ng-template pTemplate="header">
        <tr>
          <!-- singleSelect header -->
          @if (selectionSetting === selectionSettingEnum.SingleSelect) {
            <th class="singleSelectColumn">{{'genericSearch.rowselect' | hisUi}}</th>
          }

          <!-- multiSelect header -->
          @if (selectionSetting === selectionSettingEnum.MultiSelect || doShowJobStarter) {
            <th class="multiSelectColumn">
              <p-tableHeaderCheckbox (click)="toggleSelectAll()" class="hideOnBreakpointSmall"
              [title]="rowContext.rows.length === rowContext.activePageSelection.length ? ('genericSearch.deselectAllOfPage' | hisUi) : ('genericSearch.selectAllOfPage' | hisUi)" />
              <span class="hideOnBreakpointLarge">{{'genericSearch.rowselect' | hisUi}}</span>
            </th>
          }

          <!-- action header before data columns -->
          @if (rowAction && showActionsBefore) {
            <th class="actionsBeforeColumn">{{'de.his.javang.aktionen' | hisUi}}
              @if (toggleTableFilter) {
                <div>
                  <!-- Buttons zum Ausführen und Zurücksetzen des Filters linke Aktionen-Spalte -->
                  <button
                    hisImage="filter"
                    class="icon"
                    [title]="'genericSearch.resultTable.tableFilter.applyFilter' | hisUi"
                    (click)="onFilterTable()">
                  </button>
                  <button
                    hisImage="filter_reset"
                    class="icon"
                    [title]="'genericSearch.resultTable.tableFilter.resetFilter' | hisUi"
                    (click)="onResetFilter()">
                  </button>
                </div>
              }
            </th>
          }
          
          @if (rowCustomIcon) {
            <th>
                <div>{{ customIconsColumnHeading | hisUi }}</div>
            </th>  
          }

          <!-- data headers -->
          @for (column of columns; track column) {
            @if (column.visible) {
              <th [pSortableColumnDisabled]="!column.sortable" [pSortableColumn]="column.sortPath" [id]="column.id">
                {{column.label | hisUi}}
                @if (column.sortable) {
                  <span>
                    <p-sortIcon [field]="column.sortPath"></p-sortIcon>
                  </span>
                }
                <!-- Filter mit Eingabefeldern im Table Header -->
                @if (toggleTableFilter) {
                  <div>
                    @if (column.visible && column.filterable !== false) {
                      <input
                        [title]="'genericSearch.resultTable.tableFilter.applyFilter' | hisUi"
                        pInputText type="text"
                        [(ngModel)]="filter[column.filterPath]"
                        (ngModelChange)="onFilter($event, column)"
                        (keydown.enter)="$event.stopPropagation(); onFilterTable()"
                        (keydown.space)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()"/>
                    }
                  </div>
                }
              </th>
            }
          }

          <!-- action header after data columns -->
          @if (rowAction && showActionsAfter) {
            <th>{{'de.his.javang.aktionen' | hisUi}}
              @if (toggleTableFilter) {
                <div>
                  <!-- Buttons zum Ausführen und Zurücksetzen des Filters rechte Aktionen-Spalte-->
                  <button
                    hisImage="filter"
                    class="icon"
                    [title]="'genericSearch.resultTable.tableFilter.applyFilter' | hisUi"
                    (click)="onFilterTable()">
                  </button>
                  <button
                    hisImage="filter_reset"
                    class="icon"
                    [title]="'genericSearch.resultTable.tableFilter.resetFilter' | hisUi"
                    (click)="onResetFilter()">
                  </button>
                </div>
              }
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-ri="rowIndex">
        <!-- display custom result row(s) before data rows -->
        @if (ri === 0) {
          <ng-container *ngTemplateOutlet="customResultRowsTemplate; context:{numberOfVisibleDataColumns: numberOfVisibleDataColumns}"></ng-container>
        }

        <tr> <!-- [pSelectableRow]="row" verursacht "Leertab" #235586 -->
          <!-- singleSelect buttons -->
          @if (selectionSetting === selectionSettingEnum.SingleSelect) {
            <td class="singleSelectColumn">
              <button (click)="doSingleSelect(row)" [hisImage]="hisIcon" class="icon"
              title="{{'common.assignOf' | hisUi:getTooltipParam(row)}}"></button>
            </td>
          }
          <!-- multiSelect checkboxes -->
          @if (selectionSetting === selectionSettingEnum.MultiSelect || doShowJobStarter) {
            <td class="multiSelectColumn">
              <p-tableCheckbox [value]="row" ariaLabel="{{getTableCheckboxTitleForRow(row)}}"
                title="{{getTableCheckboxTitleForRow(row)}}">
              </p-tableCheckbox>
            </td>
          }
    
          <!-- action buttons before data columns -->
          @if (rowAction && showActionsBefore) {
            <td ngClass="singleLine" class="actionsBeforeColumn">
              <ng-container *ngTemplateOutlet="rowAction; context:{index: ri, row: row}"></ng-container>
            </td>
          }

          @if (rowCustomIcon) {
            <td ngClass="singleLine">
                <ng-container *ngTemplateOutlet="rowCustomIcon; context:{index: ri, row: row}"></ng-container>
            </td>  
          }
          
          <!-- the data -->
          @for (column of columns; track column; let columnIndex = $index) {
            @if (column.visible) {
              <td>
                <his-search-result-table-cell
                [rowId]="row.getAt(idColumnIndex)"
                [row]="row"
                  [column]="column"
                  [columnIndex]="columnIndex"
                  [ri]="ri"
                  [defaultAction]="defaultAction"
                  [defaultActionRoute]="defaultActionRoute"
                  [defaultActionUrl]="defaultActionUrl"
                  [showBackButton]="showBackButton"
                  [defaultActionRouteQueryParams]="defaultActionRouteQueryParams"
                  [isDefaultColumn]="column.id === defaultColumn"
                  [defaultActionToolTip]="defaultActionToolTip"
                  [defaultActionRowRight]="defaultActionRowRight"
                  (beforeNavigateDefaultRoute)="onBeforeNavigateDefaultRoute()"
                  >
                </his-search-result-table-cell>
              </td>
            }
        }

          <!-- action buttons after data columns -->
          @if (rowAction && showActionsAfter) {
            <td ngClass="singleLine" class="actionsAfterColumn">
              <ng-container *ngTemplateOutlet="rowAction; context:{index: ri, row: row}"></ng-container>
            </td>
          }
        </tr>
      </ng-template>

      <!-- "No data" message. Despite the new handling in his-search-form.submitSearch() still needed for combined his-search-form-results -->
      <ng-template pTemplate="emptymessage">
        @if (initialLoadFinished && customResultRowsTemplate) {
          <ng-container *ngTemplateOutlet="customResultRowsTemplate; context:{numberOfVisibleDataColumns: numberOfVisibleDataColumns}"></ng-container>
        }
        @if (initialLoadFinished && !customResultRowsTemplate) {
          <tr>
            @if (currentPageNumber > 1) {
              <td  [attr.colspan]="99">{{'genericSearch.emptyResultPageAfterDelete' | hisUi}}</td>
              } <!-- declaring too many columns is ok here -->
              @if (currentPageNumber === 1) {
                <td [attr.colspan]="99">{{'genericSearch.emptyResult' | hisUi}}</td>
                } <!-- declaring too many columns is ok here -->
              </tr>
            }
          </ng-template>

          <!-- total row count etc. -->
          <!-- @if (showPaginator) { -->
          <ng-template pTemplate="paginatorright">
            @if (totalRowCount>0) {
              <div>
                <his-rows-per-page #resultRowsPerPageComponent
                  [maxRows]="maxRows"
                  (rowsPerPageChange)="rowsPerPageChanged($event)"
                  [totalRowCount]="totalRowCount"
                  [currentPageNumber]="currentPageNumber"
                  [totalNumberOfPages]="totalNumberOfPages">
                </his-rows-per-page>
              </div>
            }
          </ng-template>
          <!-- } @else { -->
          <!--     xxx-->
          <!-- } -->
    </p-table>

    <ng-content select="[customContentBelowTable]"></ng-content>

    <ng-content select="[customBottomResultButtons]"></ng-content>

    <!-- advanced search -->
    <div class="genericSearchButtons">
      <!-- Standard buttons -->
      @if (showNewSearchButton) {
        <button type="submit" iconPos="left" (click)="newSearch()">
          <span>{{'de.his.javang.newsearch'|hisUi}}</span>
        </button>
      }
      @if (showChangeSearchButton) {
        <button type="submit" iconPos="left" (click)="changeSearch()">
          <span>{{'de.his.javang.changesearch'|hisUi}}</span>
        </button>
      }
    </div>
  </ng-template> <!-- end of ng-template for result table -->

</div>
